import React from 'react'

// Reactor UI
import { Box, Flex } from 'reactor-ui'

// Reactor
import DefaultThemeSidebar from './DefaultThemeSidebar'


const DefaultThemeZoneLayout = ({
  baseUrl,
  zoneContent
}) => {
  return (
    <>
      <DefaultThemeSidebar baseUrl={baseUrl} />

      <Box sx={{
        // width: 1,
        // marginLeft: layoutConfig.sidebar.extended ? 'contentWithExtendedSidebar' : 'contentWithSidebar',
        transition: 'all 0.2s ease',
        '@media print': {
          ml: 0,
          mt: 5
        },
      }}>
        {zoneContent}
      </Box>
    </>
  )
}

export default DefaultThemeZoneLayout